import { Form } from "antd";
import { LandingImageFormDragger } from "./LandingImageFormDragger";
import style from "./style.module.css";
import { MarkdownField } from "@/ui-components/commonComponents/MarkdownField/MarkdownField";

const LANDING_PAGE_PHOTO_ID = "landing-page-photo";
const LANDING_TEXT_EDITOR_ID = "landing-page-text";
const LANDING_TEXT_DESCRIPTION_ID = "landing-page-text-description";

export function LandingPageFields() {
  const landingImageFile = Form.useWatch("landingImageFile");
  const hasLandingImage = Boolean(landingImageFile);
  return (
    <>
      <Form.Item label="Landing Page Photo" htmlFor={LANDING_PAGE_PHOTO_ID}>
        <div className={style.landingImageContainer}>
          <Form.Item validateFirst={true} className={style.image}>
            <Form.Item name="landingImageFile" valuePropName="file" noStyle={true}>
              <LandingImageFormDragger id={LANDING_PAGE_PHOTO_ID} />
            </Form.Item>
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item label="Landing Page Text" htmlFor={LANDING_TEXT_EDITOR_ID}>
        <p className={style.fieldDescription} id={LANDING_TEXT_DESCRIPTION_ID}>
          Candidates will see this the first time they begin the assessment after the introduction page. Use it to share
          role-specific details so they can determine whether to continue.
        </p>
        <Form.Item
          name="landingText"
          dependencies={["landingImageFile"]}
          rules={[
            {
              validator: async (_, value) => {
                if (hasLandingImage && (!value || value.trim() === "")) {
                  throw new Error("Landing text is required when a landing image is provided.");
                }
              },
            },
          ]}
          noStyle={true}
        >
          <MarkdownField
            textareaProps={{ id: LANDING_TEXT_EDITOR_ID, "aria-describedby": LANDING_TEXT_DESCRIPTION_ID }}
          />
        </Form.Item>
      </Form.Item>
    </>
  );
}
